/** 顶部图标、banner、搜索、购物车区域 */
<template>
  <div class="content">
    <div class="header">
      <el-row style="width: 100%;padding: 15px 0 10px 0;display: flex;align-items: center;">
        <el-col :span="6" style="text-align: left;display: flex;align-items: center;">
          <!-- <img src="static/index/logo.png" style="width: 100px;height: auto;cursor: pointer;"  @click="routLinkTo('/indexpage/index')"> -->
          <img src="static/index/logo_.png" style="width: 100px;height: auto;cursor: pointer;"  @click="routLinkTo('/indexpage/index')">
          <!-- <img src="static/base64.png" style="width: 90px;height: auto;cursor: pointer;"  @click="routLinkTo('/indexpage/index')"> -->
        </el-col>
        <el-col :span="18">
          <div style="width:100%;">
            <div class="navbtn">
              <div v-for="item in inType" :key="item.value" @click="routLinkTo(item.route)"
                :class="item.route == activeRouteName ? 'btnitem cruutbtn' : 'btnitem'">
                <i :class="item.img"></i>
                <span>{{ item.des }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="headerserch">
      <el-row style="width: 100%;padding: 10px 0;">
        <el-col :span="24" style="display: flex;flex-wrap: nowrap;justify-content: space-around;">
          <div class="rowleft">
            <el-input placeholder="请输入商品名称" v-model="searchKeyWord" @keyup.enter="seachEnter" class="input-with-select"
              style="height: 45px;" @blur="inputBlur" clearable @clear="inputBlur">
              <el-select :value="selectValue" slot="prepend" placeholder="请选择商品分类" style="width: 180px;height: 48px;">
                <el-option label="全部商品" value="1"></el-option>
              </el-select>
              <el-button slot="append" style="background-color: #F74747;color: #fff;"
                @click="keyWordSearch">搜索</el-button>
            </el-input>
          </div>
          <div class="rowright">
            <el-button style="margin-right:10px;background-color: #F74747;color: #fff;border-color: #F74747;" @click="routLinkTo('/cart/shoppingCart')">
              <i class="iconfont icon-yihangyige4"></i>
              我的购物车({{ cartNum }})
            </el-button>
            <el-button @click="routLinkTo('/quickly')">
              <i class="iconfont icon-dingdan" style="color: #F74747;"></i>
              快速下单
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="hotkey">
            <div class="key" @click="hotSearch('除湿机')">除湿机</div>
            <div class="key" @click="hotSearch('水箱')">水箱</div>
            <div class="key" @click="hotSearch('风幕机')">风幕机</div>
            <div class="key" @click="hotSearch('高达空间机组')">高达空间机组</div>
            <div class="key" @click="hotSearch('换气扇')">换气扇</div>
            <div class="key" @click="hotSearch('备品备件')">备品备件</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { cartCount } from "@/api/cart.js";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "TopTypeNav",
  props: {
    obj: Object,
  },
  data() {
    return {
      activeRoute: "/indexpage/index",
      searchKeyWord: "",
      activeRouteName: '/indexpage/index',
      inType: [
        {
          value: 0,
          img: 'el-icon-picture-outline-round',
          des: '首页',
          route: '/indexpage/index'
        },
        {
          value: 1,
          img: 'el-icon-attract',
          des: '全部商品',
          route: '/indexpage/productlist'
        },
        {
          value: 2,
          des: '我要询价',
          img: 'el-icon-c-scale-to-original',
          route: '/addInventory'
        },
        {
          value: 3,
          des: '快速下单',
          img: 'el-icon-thumb',
          route: '/quickly'
        }
      ],
      selectValue: "1"
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path,'to.path');
      this.activeRoute = to.path;
      this.activeRouteName = to.path;
    },
  },
  computed: {
    ...mapGetters([
      "cartNum", // 购物车商品数量
    ]),
  },
  mounted() {
    this.getCartNum();
    this.activeRoute = this.$route.path;
    this.activeRouteName = this.$route.path;
  },
  methods: {
    ...mapMutations({
      setCartNum: "SET_CARTNUM", // 修改购物车商品数量
    }),
    //导航跳转
    routLinkTo(val) {
      this.activeRouteName = val
      if (val === '/quickly') {
        this.$router.push(val)
      } else {
        this.$router.push(val)
      }
    },
    seachEnter(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.keyWordSearch(); //搜索按钮的回调
      }
    },

    // 获取购物车商品数量
    async getCartNum() {
      var res = await cartCount();
      if (res.status === 200) {
        this.setCartNum(res.data.count);
      } else {
        this.$message.warning(res.msg);
      }
    },
    // routLinkTo(val) {
    //   if (val === '/quickly') {
    //     this.$router.push(val)
    //     //   const { href } = this.$router.resolve({
    //     //   path: "/quickly",

    //     // });
    //     // window.open(href, "_blank");
    //   } else {
    //     this.$router.push(val)
    //   }
    // },
    //热搜
    hotSearch(key) {
      this.searchKeyWord = key;
      this.keyWordSearch()
    },
    keyWordSearch() {
      this.searchKeyWord = this.searchKeyWord.trim()
      this.$router.push({
        path: "/indexpage/productlist",
        query: {
          keyword: this.searchKeyWord,
          //date:new Date().getTime()
        },
      });
    },
    inputBlur(){
      if(this.$route.path == '/indexpage/index') return;
      this.searchKeyWord = this.searchKeyWord.trim();
      if(this.searchKeyWord.length == 0){
        this.$router.push({
        path: "/indexpage/productlist",
        query: {
          keyword: '',
        },
      });
      }
    }
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  height: 100%;
  background-color: #F6F6F8;

  .header {
    width: 1440px;
    height: 100px;
    margin: 0 auto;
    background-color: #F6F6F8;

    .navbtn {
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #333;
      display: flex;
      flex-wrap: nowrap;
      justify-content: end;

      .btnitem {
        margin: 0 20px;
        cursor: pointer;

        i {
          font-style: normal;
        }

        &:hover {
          color: #F74747;
          border-bottom: 1px solid #F74747;
        }
      }

      .cruutbtn {
        color: #F74747;
        border-bottom: 1px solid #F74747;
      }
    }
  }

  .headerserch {
    width: 1440px;
    height: auto;
    margin: 0 auto;
    color: #333;


    .rowleft {
      width: 75%;

      /deep/input {
        height: 45px !important;
      }
    }

    .rowright {
      width: 25%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: end;
    }

    /deep/.el-input-group__append {
      background-color: #F74747;
      border-color: #F74747;
    }
  }

  .hotkey {
    display: flex;
    flex-wrap: nowrap;
    justify-content: start;
    margin: 5px 0 15px 0;

    .key {

      cursor: pointer;
      color: #333;
      font-size: 13px;
      margin: 0 10px;
    }
  }
}

.el-select-dropdown__item.selected {
  background-color: #f3f3f3;
  color: #F74747;
}

/deep/.el-button:focus, .el-button:hover{
  color: #F74747;
  background-color: #fff;
}
/deep/.el-popper[x-placement^=bottom]{
  height: 48px;
}
/deep/.el-scrollbar{
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopTypeNav.vue